import React from "react";
import "./WitEarnHome.scss"
import TagContent from "../../components/TagContent/TagContent";
import Button from "../../components/Button/Button";
import UserStack from "../../components/UserStack/UserStack";
import { sortByOrderAscending } from "../../helper/helper";
const WitEarnHomeHero = ({ components }) => {

    const styledHeaderText = (data) => {
        const parts = data?.text?.split(data.highlighted);
        return (<>
            {parts[0]}
            <span>{data.highlighted}</span>
            {parts[1]}
        </>)
    };
    const renderButtonComponents = (key, component) => {
        switch (component.ID) {
            case "Button":
                return <Button fontSize={component?.Props?.fontSize} fontWeight={component?.Props?.fontWeight} buttonText={component?.Props?.buttonText} isPrimary={component?.Props?.isPrimary} />
            default:
                return <div />
        }
    }
    const getButtonComponents = (leftComponents) => {
        return (
            <div className="WitEarnHomeHero-btn-container">
                {sortByOrderAscending(leftComponents).map((component, key) => {
                    return renderButtonComponents(key, component)
                })}

            </div>
        )
    }
    const renderLeftComponents = (key, component) => {
        switch (component.ID) {
            case "TagComponent":
                return <TagContent text={component?.Props?.text} isList={component?.Props?.isList} />
            case "HeaderText":
                return <div className="WitEarnHomeHero-header">{styledHeaderText(component?.Props)}</div>
            case "HeaderSubText":
                return <div className="WitEarnHomeHero-content">{component?.Props?.text}</div>

            case "HeaderButtonContainer":
                return getButtonComponents(component?.Components)
            case "HeaderUserStack":
                return <div className="WitEarnHomeHero-stack">
                    <UserStack userCount={component?.Props?.usersCount} />
                </div>

            default:
                return <div />
        }

    }
    const getLeftComponents = (leftComponents) => {
        return (
            <div className="WitEarnHomeHero-inner-left">
                {sortByOrderAscending(leftComponents).map((component, key) => {
                    return renderLeftComponents(key, component)
                })}

            </div>
        )
    }
    const getComponents = (key, component) => {
        switch (component.ID) {
            case "WitEarnHomeHeroLeft":
                return getLeftComponents(component.Components)
            case "WitEarnHomeHeroRight":
                return <div className="WitEarnHomeHero-inner-right">
                    <img alt="" src={component?.Props?.src} />
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="WitEarnHomeHero">
            <div className="WitEarnHomeHero-inner">
                {sortByOrderAscending(components).map((component, key) => {
                    return getComponents(key, component)
                })}
            </div>
        </div>
    )

}
export default WitEarnHomeHero